import { CustomAudience } from 'api/customAudiences/types'

export default {
  audiences: [
    {
      name: 'Target accounts',
      description: 'All the target accounts.',
      id: 1234,
      targetAccounts: true,
      utmParams: false,
      conditions: [],
    },
    {
      name: 'US visitors',
      description: 'All visitors in the US.',
      id: 1233,
      targetAccounts: false,
      utmParams: false,
      conditions: [
        {
          source: 'INTEL',
          propertyName: 'company.country',
          operator: 'equals',
          values: ['United States'],
        },
      ],
    },
    {
      name: 'UTM visitors',
      description: 'All utm visitors.',
      id: 1232,
      targetAccounts: false,
      utmParams: true,
      conditions: [],
    },
  ] as CustomAudience[],
}
